import { forwardRef, useEffect, useImperativeHandle } from "react";
import { DataTable } from "primereact/datatable";
import { useAPIGetJabatan } from "../api/api-get-jabatan";
import { Column } from "primereact/column";
import JabatanFilter from "./jabatan-filter";
import { genTemplateBodyText } from "@components/utils/TableTemplateBodyGenerator";
import { Paginator } from "primereact/paginator";
import { Button } from "primereact/button";

const JabatanList = forwardRef((props, ref) => {
  const { onClickRowDelete, onClickRowEdit, onClickAddNew } = props;

  const {
    loading,
    listData,
    fetchListData,
    filterValue,
    setFilterValue,
    handleOnClickRefresh,
    handleOnPage,
    paging,
    handleOnUpdateViewRow,
    handleOnDeleteViewRow,
  } = useAPIGetJabatan();

  useImperativeHandle(ref, () => ({
    handleOnUpdateViewRow: (row) => {
      handleOnUpdateViewRow(row);
    },
    handleOnDeleteViewRow: (row) => {
      handleOnDeleteViewRow(row);
    },
  }));

  // use effect section

  useEffect(() => {
    fetchListData({ page: paging.page, take: paging.take });
  }, []);

  //  custom ui section

  const kodeBodyTemplate = (row) => {
    return genTemplateBodyText({
      row: row,
      field: "kode",
    });
  };

  const namaBodyTemplate = (row) => {
    return genTemplateBodyText({
      row: row,
      field: "nama",
    });
  };

  const actionBodyTemplate = (row) => {
    return (
      <div className="row-center-center gap-2">
        <Button
          icon={row.id && row.id > 0 ? "pi pi-pencil" : "pi pi-plus"}
          rounded
          severity={row.id && row.id > 0 ? "primary" : "success"}
          className={`${
            row.id && row.id > 0 ? "bg-indigo-400" : "bg-emerald-400"
          } max-w-[1.85rem] max-h-[1.85rem]`}
          onClick={() => {
            if (onClickRowEdit) onClickRowEdit(row);
          }}
          pt={{ icon: { className: "!text-xs" } }}
        />
        <Button
          icon="pi pi-trash"
          rounded
          severity="danger"
          className="bg-red-400 max-w-[1.85rem] max-h-[1.85rem]"
          onClick={() => {
            if (onClickRowDelete) onClickRowDelete(row);
          }}
          pt={{ icon: { className: "!text-xs" } }}
        />
      </div>
    );
  };

  return (
    <div className="col-start-start w-full gap-4">
      {/* filter section */}
      <div className="elevated-card-tight-vertical row-start-start w-full gap-4">
        <JabatanFilter
          filterValue={filterValue}
          setFilterValue={setFilterValue}
          onClickRefresh={handleOnClickRefresh}
        />
      </div>

      {/* table section */}
      <div className="elevated-card-tight-vertical col-start-end w-full gap-2">
        <div className="row-start-centerw w-full">
          <Button
            icon="pi pi-plus"
            label="Tambah Baru"
            onClick={() => {
              if (onClickAddNew) onClickAddNew();
            }}
          />
        </div>
        <DataTable
          dataKey="id"
          className="w-100"
          loading={loading}
          showGridlines
          stripedRows
          value={listData}
        >
          <Column
            field="no"
            header="#"
            className="text-center"
            headerClassName="w-[4rem]"
            alignHeader={"center"}
          />
          <Column
            field=""
            header="Action"
            alignHeader={"center"}
            headerClassName="w-[8rem]"
            body={actionBodyTemplate}
          />
          <Column field="kode" header="Kode" body={kodeBodyTemplate} />
          <Column field="nama" header="Nama" body={namaBodyTemplate} />
        </DataTable>
        <Paginator
          first={parseInt(paging.take) * (paging.page - 1)}
          rows={parseInt(paging.take)}
          totalRecords={parseInt(paging.total)}
          rowsPerPageOptions={[5, 10, 20, 50]}
          onPageChange={handleOnPage}
        />
      </div>
    </div>
  );
});

export default JabatanList;
